var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.dialogMode ? "div" : "page",
    { tag: "component", staticClass: "agent-level" },
    [
      _c(
        "div",
        {
          staticClass: "page-content",
          class: { "page-content--dialog": _vm.dialogMode },
        },
        [
          _c(
            "div",
            { staticClass: "actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v("新增代理等级")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                stripe: "",
                size: "small",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "agent_level",
                  label: "代理等级",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(`LV${scope.row.agent_level}`) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "level_name",
                  label: "等级名称",
                  width: "120",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "need_share_num",
                  label: "新增直属下级(人数)",
                  "min-width": "150",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("formatShareNum")(scope.row.need_share_num)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "upgrade_need_gold",
                  label: "晋级条件(需再获得佣金)",
                  "min-width": "160",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("centsToYuan")(scope.row.upgrade_need_gold)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "share_one_rate",
                  label: "直属代理佣金比例",
                  "min-width": "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("formatRate")(scope.row.share_one_rate)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  prop: "share_two_rate",
                  label: "二级代理佣金比例",
                  "min-width": "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("formatRate")(scope.row.share_two_rate)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  fixed: "right",
                  prop: "count",
                  label: "代理数量",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleViewAgents(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.count))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  resizable: false,
                  fixed: "right",
                  label: "操作",
                  width: "120",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "page-dialog center-dialog",
          attrs: {
            "append-to-body": "",
            visible: _vm.addLevelDialogVisible,
            title: _vm.editId ? "编辑代理等级" : "新增代理等级",
            width: "600px",
          },
          on: {
            close: function ($event) {
              _vm.addLevelDialogVisible = false
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addLevelFormRef",
              staticClass: "add-level-form",
              attrs: {
                model: _vm.addLevelForm,
                rules: _vm.addFormRules,
                "label-width": "180px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "代理等级", prop: "agent_level" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.addLevelForm.agent_level,
                      callback: function ($$v) {
                        _vm.$set(_vm.addLevelForm, "agent_level", $$v)
                      },
                      expression: "addLevelForm.agent_level",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "等级名称", prop: "level_name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.addLevelForm.level_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.addLevelForm, "level_name", $$v)
                      },
                      expression: "addLevelForm.level_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "新增直属下级(人数)",
                    prop: "need_share_num",
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: { controls: false, step: 1, placeholder: "请输入" },
                    model: {
                      value: _vm.addLevelForm.need_share_num,
                      callback: function ($$v) {
                        _vm.$set(_vm.addLevelForm, "need_share_num", $$v)
                      },
                      expression: "addLevelForm.need_share_num",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "晋级条件(需再获得佣金)",
                    prop: "upgrade_need_gold",
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: { controls: false, step: 1, placeholder: "请输入" },
                    model: {
                      value: _vm.addLevelForm.upgrade_need_gold,
                      callback: function ($$v) {
                        _vm.$set(_vm.addLevelForm, "upgrade_need_gold", $$v)
                      },
                      expression: "addLevelForm.upgrade_need_gold",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "rate-item" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "直属代理佣金比例",
                        prop: "share_one_rate",
                      },
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          controls: false,
                          step: 0.01,
                          placeholder: "请输入",
                        },
                        model: {
                          value: _vm.addLevelForm.share_one_rate,
                          callback: function ($$v) {
                            _vm.$set(_vm.addLevelForm, "share_one_rate", $$v)
                          },
                          expression: "addLevelForm.share_one_rate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "suffix" }, [_vm._v("%")]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "rate-item" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "二级代理佣金比例",
                        prop: "share_two_rate",
                      },
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          controls: false,
                          step: 0.01,
                          placeholder: "请输入",
                        },
                        model: {
                          value: _vm.addLevelForm.share_two_rate,
                          callback: function ($$v) {
                            _vm.$set(_vm.addLevelForm, "share_two_rate", $$v)
                          },
                          expression: "addLevelForm.share_two_rate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "suffix" }, [_vm._v("%")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addLevelDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleAddLevelSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("AgentCountListDialog", {
        attrs: {
          visible: _vm.agentCountListDialogVisible,
          level: _vm.agent_level,
          title: _vm.agentCountListDialogTitle,
        },
        on: {
          "update:visible": function ($event) {
            _vm.agentCountListDialogVisible = $event
          },
          closed: _vm.handleAgentCountListClosed,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }